<template>
  <NavigationLayout :accordionItems="accordionItems" />
</template>

<script setup>
import { computed } from 'vue';
import { useShaftOperationTypeNavItems } from '@/functions/operation_type_nav_items';

// Components
import NavigationLayout from '@/components/operations/operation_type_navigation_layout.vue';

const props = defineProps({
  /** Show/hide HME options in the navigation */
  showHmePolicy: { type: Boolean, required: false, default: false },
});

const { getNavigationItems } = useShaftOperationTypeNavItems();

const accordionItems = computed(() => {
  return getNavigationItems(props.showHmePolicy);
});
</script>
